import { ApolloLink } from '@apollo/client';
import { getUserLocaleKey } from 'utils/i18n';
import AuthService from '../services/Auth';
import { createOktaServiceTokenLink } from './createOktaServiceTokenLink';

export const getUserId = () => {
  const user = AuthService.getLocalUser();

  return user?.id || '';
};

export const getLanguageId = () => {
  return getUserLocaleKey();
};

export const authHeaders = new ApolloLink((operation, forward) => {
  const authToken = AuthService.getToken();
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: authToken ? `Bearer ${authToken}` : '', //The use of Bearer token here to authorize connection to users API is OK.
      'user-id': getUserId(),
    },
  }));

  return forward(operation);
});
export const authHeadersOkta = createOktaServiceTokenLink({
  projectName: 'users-api',
  getExtraHeaders: () => ({
    'user-id': getUserId(),
  }),
});

export const propertiesAuthContext = createOktaServiceTokenLink({
  projectName: 'properties-api',
  getExtraHeaders: () => ({
    'user-id': getUserId(),
    'application-from': 'web',
    'language-id': getLanguageId(),
  }),
});

export const geospatialAuthContext = createOktaServiceTokenLink({
  projectName: 'geospatial-api',
  getExtraHeaders: () => ({
    'user-id': getUserId(),
    'application-from': 'web',
    'language-id': getLanguageId(),
  }),
});
